// removed by extract-text-webpack-plugin
module.exports = {"component":"_3DzryjVTS-SAYevzaBLWRl"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AccordionComponent/AccordionComponent.scss
 ** module id = 942
 ** module chunks = 0
 **/